import React from 'react';
import PropTypes from 'prop-types';
import { ConsolidatedPaperComponent } from './ConsolidatedPaperComponent';

const ConsolidatedPaperContainer = ({
  header,
  leftChart,
  leftInfoPapers,
  rightChart,
  rightInfoPapers,
  isLoading = false,
}) => {
  return (
    <ConsolidatedPaperComponent
      header={header}
      leftChart={leftChart}
      leftInfoPapers={leftInfoPapers}
      rightChart={rightChart}
      rightInfoPapers={rightInfoPapers}
      isLoading={isLoading}
    ></ConsolidatedPaperComponent>
  );
};

ConsolidatedPaperContainer.propTypes = {
  header: PropTypes.object.isRequired,
  leftChart: PropTypes.object,
  leftInfoPapers: PropTypes.object,
  rightChart: PropTypes.object,
  rightInfoPapers: PropTypes.object,
  isLoading: PropTypes.bool,
};

export { ConsolidatedPaperContainer };
